import { useState } from "react";
import "./Stock.css";
import axios from "axios";

function Stock({ products, fetchprod }) {
  const [stockUpdates, setStockUpdates] = useState([]);
  let serialNo = 1;

  const updateStock = async () => {
    if (stockUpdates.length === 0) return alert("No changes to update.");

    try {
      for (const item of stockUpdates) {
        const formData = new FormData();
        formData.append("id", item.product_id);
        formData.append("size", item.size);
        formData.append("update_stock", item.stock);

        await axios.post(
          `${process.env.REACT_APP_BASEURL}/apis/vendor/stock_update.php`,
          formData
        );
      }

      alert("Stock updated successfully");
      setStockUpdates([]);
      fetchprod();
    } catch (err) {
      console.error("Error updating stock:", err);
      alert("Failed to update stock");
    }
  };

  const handleStockChange = (product_id, size, value) => {
    setStockUpdates((prev) => {
      const updated = [...prev];
      const index = updated.findIndex(
        (item) => item.product_id === product_id && item.size === size
      );

      if (index !== -1) {
        updated[index].stock = value;
      } else {
        updated.push({ product_id, size, stock: value });
      }

      return updated;
    });
  };

  return (
    <div>
      <h1 className="dashboard-heading">Stock</h1>
      <div className="stock-page">
        {/* Stat Cards */}
        <div className="stock-cards">
          <Card title="Total Products" count={products.length} />
          <Card
            title="Active"
            count={products.filter((p) => p.status === "Active").length}
          />
          <Card
            title="Inactive"
            count={products.filter((p) => p.status === "Inactive").length}
          />
          <Card
            title="Out of Stock"
            count={
              products.filter(
                (p) =>
                  Array.isArray(p.stock) &&
                  p.stock.some((s) => Number(s.trim()) === 0)
              ).length
            }
          />
        </div>
        {/* Editable Table */}
        <table className="stock-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Product</th>
              <th>Size</th>
              <th>Stock</th>
              <th>Status</th>
              <th>Update Stock</th>
            </tr>
          </thead>
          <tbody>
            {products.flatMap((prod) => {
              const sizes = prod.prod_size || [];
              const stocks = prod.stock || [];

              return sizes.map((size, i) => (
                <tr key={`${prod.product_id}-${i}`}>
                  <td>{serialNo++}</td>
                  <td>
                    {prod.product_id} - {prod.prod_name}
                  </td>
                  <td>{size.trim()}</td>
                  <td>{stocks[i]?.trim() || ""}</td>
                  <td>{prod.status}</td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      placeholder="Enter qty"
                      onChange={(e) =>
                        handleStockChange(
                          prod.product_id,
                          size.trim(),
                          e.target.value
                        )
                      }
                    />
                  </td>
                </tr>
              ));
            })}
          </tbody>
        </table>
        <div className="button-wrapper2">
          <button className="update-stock-btn" onClick={updateStock}>
            Update the stock
          </button>
        </div>
      </div>
    </div>
  );
}

function Card({ title, count }) {
  return (
    <div className="stock-card">
      <h4>{title}</h4>
      <p>{count}</p>
    </div>
  );
}

export default Stock;
